// Angular or other modules
import { BrowserModule, Title } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { NgModule } from "@angular/core";
import { Http, HttpModule, RequestOptions, XHRBackend } from "@angular/http";
import { Router, RouterModule } from "@angular/router";
import {
    AutoCompleteModule,
    BlockUIModule,
    CheckboxModule,
    DataTableModule,
    DialogModule,
    GrowlModule,
    ProgressBarModule,
    ProgressSpinnerModule,
    SharedModule,
    TabViewModule,
    TooltipModule,
} from "primeng/primeng";

// Components
import { AddRequestComponent } from "./requests/request/add/add-request.component";
import { AdminLayoutComponent } from "./layout/admin-layout/admin-layout.component";
import { AppComponent } from "./app.component";
import { BlankLayoutComponent } from "./layout/blank-layout/blank-layout.component";
import { ContactInfoReviewComponent } from "./common/program-editors/review/contact-info/contact-info-review.component";
import { DataTablePaginator } from "./common/datatable-paginator/datatable-paginator.component";
import { EditRequestComponent } from "./requests/request/edit/edit-request.component";
import { ImportToolComponent } from "./programs/import-tool/import-tool.component";
import { LoginComponent } from "./login/login.component";
import { MapComponent } from "./map/map.component";
import { MergeToolComponent } from "./programs/merge-tool/merge-tool.component";
import { ProgramComponent } from "./programs/program/program.component";
import { ProgramContactInfoEditorComponent } from "./common/program-editors/contact-info/program-contact-info-editor.component";
import { ProgramDetailsReviewComponent } from "./common/program-editors/review/details/program-details-review.component";
import { ProgramDetailsEditorComponent } from "./common/program-editors/details/program-details-editor.component";
import { ProgramListComponent } from "./programs/program-list/program-list.component";
import { ProgramRequestSubmissionComponent } from "./common/program-editors/submit/program-request-submission.component";
import { ProgramServicesReviewComponent } from "./common/program-editors/review/services/program-services-review.component";
import { ProgramServicesEditorComponent } from "./common/program-editors/services/program-services-editor.component";
import { PublicLayoutComponent } from "./layout/public-layout/public-layout.component";
import { PublicProfileComponent } from "./programs/public-profile/public-profile.component";
import { RequestListComponent } from "./requests/request-list/request-list.component";
import { SelectizeComponent } from "./common/selectize-component/selectize.component";

import { AdditionReviewComponent } from "./requests/review/add/addition-review.component";
import { EditReviewComponent } from "./requests/review/edit/edit-review.component";
import { DeleteReviewComponent } from "./requests/review/delete/delete-review.component";
import { RequesterReviewComponent } from "./common/program-editors/review/requester/requester-review.component";


// Services
import { AppService } from "./app.service";
import { DomainService } from "./common/guards/domain.service";
import { ImportService } from "./programs/import-tool/import.service";
import { LoginService } from "./login/login.service";
import { MapService } from "./map/map.service";
import { MapValuesService } from "./map/map-values.service";
import { MessageService } from "primeng/components/common/messageservice";
import { ProgramService } from "./programs/program.service";
import { ProgramEditorService } from "./common/program-editors/program-editor.service";
import { RequestService } from "./requests/request.service";
import { TypesService } from "./common/types.service";

// Route Stuff
import { AuthGuard } from "./common/guards/auth.guard";
import { PublicDomainGuard } from "./common/guards/public-domain.guard";
import { AdminDomainGuard } from "./common/guards/admin-domain.guard";
import { ActNowHttp } from "./act-now.http";
import { routing } from "./app.routing";

// Pipes
import { AddOnePipe } from "./common/add-one.pipe";

declare global {
    interface Window { google: any; grecaptcha: any; }
}

export function actnowHttpFactory(backend: XHRBackend, options: RequestOptions, router: Router) {
    return new ActNowHttp(backend, options, router);
}

@NgModule({
    declarations: [
        AdditionReviewComponent,
        AddOnePipe,
        AddRequestComponent,
        AdminLayoutComponent,
        AppComponent,
        BlankLayoutComponent,
        ContactInfoReviewComponent,
        DataTablePaginator,
        DeleteReviewComponent,
        EditRequestComponent,
        EditReviewComponent,
        ImportToolComponent,
        LoginComponent,
        MapComponent,
        MergeToolComponent,
        ProgramContactInfoEditorComponent,
        ProgramDetailsReviewComponent,
        ProgramDetailsEditorComponent,
        ProgramListComponent,
        ProgramRequestSubmissionComponent,
        ProgramServicesReviewComponent,
        ProgramServicesEditorComponent,
        PublicProfileComponent,
        PublicLayoutComponent,
        ProgramComponent,
        RequestListComponent,
        RequesterReviewComponent,
        SelectizeComponent
    ],
    imports: [
        AutoCompleteModule,
        BlockUIModule,
        BrowserAnimationsModule,
        BrowserModule,
        CheckboxModule,
        DataTableModule,
        DialogModule,
        FormsModule,
        GrowlModule,
        HttpModule,
        ProgressBarModule,
        ProgressSpinnerModule,
        RouterModule,
        routing,
        SharedModule,
        TabViewModule,
        TooltipModule
    ],
    providers: [
        AppService,
        AuthGuard,
        AdminDomainGuard,
        PublicDomainGuard,
        DomainService,
        ImportService,
        LoginService,
        MapService,
        MapValuesService,
        MessageService,
        ProgramEditorService,
        ProgramService,
        RequestService,
        Title,
        TypesService,
        {
            provide: ActNowHttp,
            useFactory: actnowHttpFactory,
            deps: [XHRBackend, RequestOptions, Router]
        }
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// C:/WORK/Projects/ActNow_NG2/src/app/app.module.ts